import { TooltipProps } from "recharts";
import { colors, type } from "../styles";

/**
 * Custom recharts tooltip. Rows carry a color swatch plus the series name, so
 * identity survives even where two fills are hard to tell apart.
 */
const ChartTooltip = ({
  active,
  payload,
  label,
  labelFormatter,
  valueFormatter,
}: TooltipProps<number, string> & {
  labelFormatter?: (label: string) => string;
  valueFormatter?: (value: number) => string;
}) => {
  if (!active || !payload?.length) return null;

  return (
    <div
      style={{
        background: colors.surface,
        border: `1px solid ${colors.border}`,
        borderRadius: 8,
        padding: "8px 10px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        minWidth: 140,
      }}
    >
      <div style={{ ...type.bodySmallMedium, color: colors.ink, marginBottom: 6 }}>
        {labelFormatter ? labelFormatter(String(label)) : String(label)}
      </div>
      {payload.map(entry => (
        <div
          key={String(entry.dataKey)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
            ...type.bodySmallRegular,
            color: colors.inkMuted,
          }}
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
            <span
              style={{
                width: 8,
                height: 8,
                borderRadius: 2,
                background: entry.color,
                flexShrink: 0,
              }}
            />
            {entry.name}
          </span>
          <span style={{ color: colors.ink, fontVariantNumeric: "tabular-nums" }}>
            {valueFormatter ? valueFormatter(Number(entry.value)) : entry.value}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ChartTooltip;
